export const ONE_TIME_SERVICE = 'One time service';
